import * as yup from 'yup';

const currencyRegex = /^\d{1,},\d{2}$/;

yup.addMethod(yup.string, 'currency', function () {
  return this.test('currency', function () {
    const { path, createError } = this;
    const field = document.getElementById(path);
    return new Promise((resolve, reject) => {
      if (field && currencyRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid currency' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'minValue', function () {
  return this.test('minValue', function () {
    const { path, createError } = this;
    const field = document.getElementById(path);
    return new Promise((resolve, reject) => {
      if (field && parseInt(field.value.replace(/,/g, '')) > 0) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid minValue', type: 'min' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'multiselect', function () {
  return this.test('multiselect', function () {
    const { path, createError } = this;
    const value = document.getElementsByClassName('multiselect-' + path)[0]
      .options.length;
    return new Promise((resolve, reject) => {
      if (value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

yup.addMethod(yup.string, 'select', function () {
  return this.test('select', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && field.value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

yup.addMethod(yup.string, 'customRequired', function (msg) {
  return this.test('customRequired', function () {
    const { path, createError } = this;
    const field = document.getElementById(path);
    return new Promise((resolve, reject) => {
      if (field && currencyRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Custom message' }));
      }
    });
  });
});

const schema = yup.object().shape({
  ean: yup
    .string()
    .required()
    .trim(),
  model: yup
    .string()
    .required()
    .trim(),
  manufacturer: yup.string().select(),
  name: yup
    .string()
    .required()
    .trim(),
  sku: yup
    .string()
    .required()
    .trim(),
  supplier: yup.string().select(),
  purchasePrice: yup
    .string()
    .required()
    .currency()
    .minValue(),
  // retailSaleValue: yup
  //   .string()
  //   .required()
  //   .currency()
  //   .minValue(),
  // wholeSaleValue: yup
  //   .string()
  //   .required()
  //   .currency()
  //   .minValue(),
  stockQuantity: yup
    .string()
    .required()
    .trim(),
  // dropshippingValue: yup
  //   .string()
  //   .required()
  //   .currency()
  //   .minValue(),
  // wholesaleMinQuantity: yup
  //   .string()
  //   .required()
  //   .trim(),
  // weight: yup
  //   .string()
  //   .required()
  //   .customRequired()
  //   .minValue(),
  // length: yup
  //   .string()
  //   .required()
  //   .customRequired()
  //   .minValue(),
  // width: yup
  //   .string()
  //   .required()
  //   .customRequired()
  //   .minValue(),
  // height: yup
  //   .string()
  //   .required()
  //   .customRequired()
  //   .minValue(),
  origin: yup
    .string()
    .required()
    .trim(),
  itemType: yup
    .string()
    .required()
    .trim(),
  condition: yup
    .string()
    .required()
    .trim(),
  // ncm: yup
  //   .string()
  //   .required()
  //   .trim(),
  // cest: yup
  //   .string()
  //   .required()
  //   .trim(),
  // csosn: yup
  //   .string()
  //   .required()
  //   .trim(),
  // cfopSameState: yup
  //   .string()
  //   .required()
  //   .trim(),
  // cfopAnotherState: yup
  //   .string()
  //   .required()
  //   .trim(),
  // minDropshippingQuantity: yup
  //   .string()
  //   .required()
  //   .trim(),
  categories: yup.string().multiselect()
});

export default schema;
